import { render } from "./AutocompleteWrapper.vue?vue&type=template&id=2d5285ed"
import script from "./AutocompleteWrapper.vue?vue&type=script&lang=js"
export * from "./AutocompleteWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__